var marketResult = window.marketResult;
/*
========= CATEGORY LIST TOGGLE =========
*/
function isMobileDevice() {
    return window.innerWidth <= 990;
}

function getMaxHeight() {
    return isMobileDevice() ? '190px' : '190px';
}

function toggleCategoryList(toggleButton) {
    let list = toggleButton.previousElementSibling;
    let maxHeight = getMaxHeight();

    let toggleIcon = toggleButton.querySelector('.plp-related-collections__list--see-more__icon');
    let toggleText = toggleButton.querySelector('.plp-related-collections__list--see-more__text');

    if (list.style.maxHeight == '1000px') {
        list.style.maxHeight = maxHeight;
        toggleText.innerHTML = "See More";
        toggleIcon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
                <path d="M6 2.5V9.5M2.5 6H9.5" stroke="#005748" stroke-width="2" stroke-miterlimit="3.8637" stroke-linecap="square"/>
            </svg>      
        `;
    } else {
        list.style.maxHeight = '1000px';
        toggleText.innerHTML = "See Less";
        toggleIcon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <path d="M8.5 12H15.5" stroke="#005748" stroke-width="4" stroke-miterlimit="3.8637" stroke-linecap="square"/>
            </svg>            
        `;
    }
}

document.addEventListener('DOMContentLoaded', function(){
    let seeMoreButtons = document.querySelectorAll('.plp-related-collections__list--see-more');
    if(seeMoreButtons){
        seeMoreButtons.forEach(button => {
            button.addEventListener('click', function() {
                toggleCategoryList(button);
            });
        });
    }
    initFilterItemAccordions();
});

// Function to open the filter
function openFilter(header) {
    let filterItems = header.nextElementSibling;
    if (filterItems && filterItems.classList.contains('plp-filters__filter-items') && !filterItems.classList.contains('plp-related-collections__list')) {
        filterItems.style.maxHeight = '1000px';
        // Change button content to 'A'
        header.querySelector('.plp-filters__filter-header__icon').innerHTML = 
        `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M8.5 12H15.5" stroke="#1D1D1D" stroke-width="2" stroke-miterlimit="3.8637" stroke-linecap="square"/>
            </svg>                
        `;
    } else if (filterItems && filterItems.classList.contains('plp-filters__filter-items') && filterItems.classList.contains('plp-related-collections__list')) {
        filterItems.style.maxHeight = getMaxHeight();
        // Change button content to 'A'
        header.querySelector('.plp-filters__filter-header__icon').innerHTML = 
        `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M8.5 12H15.5" stroke="#1D1D1D" stroke-width="2" stroke-miterlimit="3.8637" stroke-linecap="square"/>
            </svg>                
        `;
        const toggleBtns = document.querySelectorAll('.plp-related-collections__list--see-more');
        toggleBtns.forEach(btn => {
            btn.style.display = "flex";
        });
    }
}

// Function to close the filter
function closeFilter(header) {
    let filterItems = header.nextElementSibling;
    if (filterItems && filterItems.classList.contains('plp-filters__filter-items')) {
        filterItems.style.maxHeight = '0px';
        // Change button content to 'B'
        header.querySelector('.plp-filters__filter-header__icon').innerHTML = 
        `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 8.5V15.5M8.5 12H15.5" stroke="#1D1D1D" stroke-width="2" stroke-miterlimit="3.8637" stroke-linecap="square"/>
            </svg>
        `;
    }

    if (filterItems && filterItems.classList.contains('plp-filters__filter-items') && filterItems.classList.contains('plp-related-collections__list')) {
        const toggleBtns = document.querySelectorAll('.plp-related-collections__list--see-more');
        toggleBtns.forEach(btn => {
            btn.style.display = "none";
        });
    }

    let list = document.querySelector('.plp-related-collections__list');
    let toggleIcon = document.querySelector('.plp-related-collections__list--see-more__icon');
    let toggleText = document.querySelector('.plp-related-collections__list--see-more__text');
    
    if (toggleText) {
        toggleText.innerHTML = "See More"
    }

    if (toggleIcon) {
        toggleIcon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
                <path d="M6 2.5V9.5M2.5 6H9.5" stroke="#005748" stroke-width="2" stroke-miterlimit="3.8637" stroke-linecap="square"/>
            </svg>      
        `;
    }
}

function updateGlobalFilterState() {
    const allFilterDivs = Array.from(document.querySelectorAll('div.plp-filters__filter-items'));
    const closeAllButton = document.querySelector('.plp-filters__close-all');
    const anyOpen = allFilterDivs.some(filterDiv => filterDiv.style.maxHeight !== "0px");
    const allClosed = allFilterDivs.every(filterDiv => filterDiv.style.maxHeight === "0px");

    if (allClosed) {
        closeAllButton.innerText = translations.products.facets.show_all;
        closeAllButton.dataset.state = "show-all";
    } else if (anyOpen) {
        closeAllButton.innerText = translations.products.facets.close_all;
        closeAllButton.dataset.state = "close-all";
    }
}

// Function to open all filters
function openAllFilters(){   
    let filterHeaders = document.querySelectorAll(".plp-filters__filter-header");
    filterHeaders.forEach(filterHeader => {
        openFilter(filterHeader);
    });
}

// Function to close all filters
function closeAllFilters(){   
    let filterHeaders = document.querySelectorAll(".plp-filters__filter-header");
    filterHeaders.forEach(filterHeader => {
        closeFilter(filterHeader);
    });
}

// Event listener for window resize
window.addEventListener('resize', function() {
    // Update max height of relevant elements on window resize
    let list = document.querySelector('.plp-related-collections__list');
    if (list && list.classList.contains('plp-related-collections__list')) {
        list.style.maxHeight = getMaxHeight();
    }
});


function initFilterItemAccordions(){
    // Select all filter header elements
    let filterHeaders = document.querySelectorAll('.plp-filters__filter-header');

    // Add click event listener to each header
    filterHeaders.forEach(header => {
        header.addEventListener('click', function() {
            // Check if the filter is currently open
            if (header.nextElementSibling.style.maxHeight === "0px") {
                openFilter(header);
            } else {
                closeFilter(header);
            }
            updateGlobalFilterState();
        });
    });

    document.querySelector('.plp-filters__close-all').addEventListener('click', function() {
        // Check if the filter is currently open
        if(this.dataset.state === "close-all"){
            closeAllFilters();
            this.innerText = translations.products.facets.show_all;
            this.dataset.state = "show-all"
        } else {
            openAllFilters();
            this.innerText = translations.products.facets.close_all;
            this.dataset.state = "close-all"
        }
    });

}

function swymCallbackFn(swat){

    document.addEventListener("swym:collections-loaded", function(){
        swat.initializeActionButtons("#hits");
    })
}

if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

async function fetchProductUrl(shopifyDomain, accessToken, productId) {
    const graphqlQuery = {
        query: `
            query {
                product(id: "${productId}") {
                    handle
                }
            }
        `
    };

    try {
        const response = await fetch(`${shopifyDomain}/admin/api/2024-01/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Access-Token': accessToken,
            },
            body: JSON.stringify(graphqlQuery)
        });

        const data = await response.json();
        const productHandle = data.data.product.handle;
        return `${shopifyDomain}/products/${productHandle}`;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

document.addEventListener('DOMContentLoaded', function(){
    /*
        SEARCH
    */
        
        // Extract 'q' parameter from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const initialQuery = urlParams.get('q') || '';

        const sectionEl = document.querySelectorAll('.plp-container');
        // const dataApiKey = document.querySelector
        const plpApiKey = sectionEl[0].dataset.apiKey;
        const plpIndexId = sectionEl[0].dataset.indexId;

        // adds elements to variables for building 'you've seen X out of Y' component.
        const totalProductsCounter = document.querySelector('.plp-sorting__product_count');
        const mobileProductsCounter = document.querySelector('.plp-filters__footer-count');
        const loadMoreContainer = document.querySelector('.collection-load-more');
        const loadMoreProgress = loadMoreContainer.querySelector('.collection-load-more-counter-progress');
        const loadMore = loadMoreContainer.querySelector('.collection-load-more');
        const loadMoreBtn = document.querySelector('#custom-load-more');

        // custom load more function for the custom load more button
        loadMoreBtn.addEventListener('click', function() {
            search.helper.nextPage();
            search.helper.search();
            setTimeout(updateTitleFromUrl, 500); 
        });

        // opens sort & filters on mobile
        var sortFilterBtn = document.querySelector('.plp-filter-sort--mobile');
        var sidbarFilters = document.querySelector('.plp-filters');
        var pageBody = document.querySelector('body');
        var closeFilters = document.querySelector('.plp-filter-sort__close');
        var plpSeeProducts = document.querySelector('.plp-see-products');
        var filtersHeader = document.querySelector('.plp-filters__header');
        var filtersFooter = document.querySelector('.plp-filters__footer');
        var clearFiltersMobile = document.querySelector('#clearFiltersMobile');

        var hierarchicalCategoriesCount = 0;
        var publisherCount = 0;
        var authorCount = 0;
        var priceRangesCount = 0;
        var bindingTypeCount = 0;
        var productTypeCount = 0;
        var platformCount = 0;
        var consoleCount = 0;
        var availableConditionsCount = 0;

        clearFilters.addEventListener('click', function() {
            search.helper.setQuery('').clearRefinements().search();
        });

        clearFiltersMobile.addEventListener('click', function() {
            search.helper.setQuery('').clearRefinements().search();
        });
        
        function openCloseFilters() {
            if (sidbarFilters.classList.contains('filters-open')) {
                pageBody.classList.remove('filters-open');
                [sidbarFilters, filtersHeader, filtersFooter].forEach(item => {
                    item.classList.remove('filters-open');
                });
            } else {
                pageBody.classList.add('filters-open');
                [sidbarFilters, filtersHeader, filtersFooter].forEach(item => {
                    item.classList.add('filters-open');
                });
            }
        }

        [sortFilterBtn, closeFilters, plpSeeProducts].forEach(element => {
            element.addEventListener("click", function() {
                openCloseFilters();
            });
        });
        // End sort & filters on mobile

        // builds the progress bar for the 'you have viewed X out of Y' element
        function stylesLoadMore(viewed, total){
            loadMore.innerText = loadMoreText.replace("{{seen}}", viewed).replace("{{total}}", total)
            loadMoreProgress.style.width = (viewed / total) * 100 + '%';
            totalProductsCounter.innerHTML = total === 1 ? total + ' ' + productCountOne : total + ' ' + productCountOther;
            mobileProductsCounter.innerHTML = total <= 1 ? 'See ' + total + ' ' + productCountOne : 'See ' + total + ' ' + productCountOther;
            // Disable "Load More" button if length is hit.
            let loadMoreButton = document.getElementById('custom-load-more');
            if (viewed === total) {
                loadMoreButton.classList.add("disabled");
                loadMoreButton.setAttribute('disabled', '');
            } else {
                if (loadMoreButton.classList.contains('disabled')) {
                    loadMoreButton.classList.remove("disabled");
                    loadMoreButton.removeAttribute('disabled');
                }
            }
        }

        function hasPromotion(style="green", content="Promotion Content") {
            return `<p class="pill ${style}">${content}</p>`
        }

        const searchClient = algoliasearch(plpIndexId, plpApiKey);

        const search = instantsearch({
          indexName: globalConfig.algoliaIndexName,
          searchClient,
          routing: true,
          insights: true,
        });

        const targetCollectionDiv = document.querySelector('div[data-collection-id]');
        const targetCollectionID = targetCollectionDiv.getAttribute('data-collection-id');
        var pageTitle = document.querySelector('.plp-header__text-container h1');

        if (targetCollectionID) {
        // filters results based on collection
            var algoliaFilterRulesString = "";
            
            if(algoliaFilterRules.length > 0) {
                algoliaFilterRulesString = algoliaFilterRules;
            } else {
                //`collection_ids:${targetCollectionID} AND fromPrice > 0`
                algoliaFilterRulesString = "collection_ids:"+targetCollectionID+" AND fromPrice > 0";
            }

            //console.log(algoliaFilterRulesString,"algoliaFilterRulesString")

            search.addWidget(
                instantsearch.widgets.configure({
                    // Use the `filters` parameter for array inclusion check
                    filters: algoliaFilterRulesString,
                    //query: initialQuery,
                })
            )
        } else {
            if (initialQuery == null || initialQuery == "") {
                pageTitle.innerText = `All Products`;
            } else {
                pageTitle.innerText = `Search “${decodeURI(initialQuery)}”`;

                var breadcrumbTitle = document.querySelector(".JS_breadcrumb_collection_title");
                if (breadcrumbTitle) {
                    breadcrumbTitle.textContent = "Search results for '" + initialQuery + "'";
                }
            }
            search.addWidget(
                instantsearch.widgets.configure({
                    filters: 'fromPrice > 0',
                    query: initialQuery,
                })
            ) 
        }

        const sessionStorageCache = instantsearch.createInfiniteHitsSessionStorageCache();

        
        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }

        function clearPlaceholders() {
            const skeletonFilter = document.querySelector('.skeleton-filter');
            if (skeletonFilter) {
                skeletonFilter.remove();
            }
        }

        let actionExecuted = false;
        
        const debouncedRenderAction = debounce(async () => {
        if (!actionExecuted) {
            const stateHelper = search.helper.state;
            const resultsHelper = search.helper.lastResults;
            let queryID;
            
            if (resultsHelper && resultsHelper._rawResults && resultsHelper._rawResults[0]) {
                queryID = resultsHelper._rawResults[0].queryID;
                window.queryID = queryID;  // If you really need this on the window object
                localStorage.setItem('algolia_queryID', queryID);
            }
        // Fetch all product link elements currently rendered on the page that haven't been updated yet
        const allProductLinks = document.querySelectorAll('#hits .ais-InfiniteHits-item a[data-product-id]:not([data-link-updated="true"])');
        const allDisplayedProductIds = Array.from(allProductLinks).map(link => link.getAttribute('data-product-id')).filter(Boolean);

        // Re-select product card elements to include those that might have been missed or cached
        const updatedProductCards = document.querySelectorAll('#hits .ais-InfiniteHits-item .product-card');
        const items = Array.from(updatedProductCards).map(card => ({
            'data-item_id': card.getAttribute('data-item_id'),
            'data-item_ean': card.getAttribute('data-item_ean'),
            'data-is_in_stock': card.getAttribute('data-is_in_stock'),
            'data-item_name': card.getAttribute('data-item_name'),
            'data-affiliation': card.getAttribute('data-affiliation'),
            'data-price': card.getAttribute('data-price'),
            'data-item_brand': card.getAttribute('data-item_brand'),
            'data-item_category': card.getAttribute('data-item_category'),
            // Extract other necessary attributes
        }));

        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        if (items.length > 0) {
            console.log(`Pushing ${items.length} product details to the data layer.`);
            pushProductListToDataLayer(items, '', 'Category', search.helper.lastResults.page * search.helper.lastResults.hitsPerPage);
        } else {
            console.log("No product details to push to the data layer.");
        }

        actionExecuted = true;
        // Reset the flag after a short delay or under certain conditions
        setTimeout(() => {
            actionExecuted = false;
        }, 100); // Slightly increased the timeout for robustness
        }
        }, 500); // Adjust debounce time as necessary
        
        // builds product grid from results
        //let itemIndex = 0; // Initialize the counter outside the widget definition
        search.addWidget(
            instantsearch.widgets.infiniteHits({
                container: "#hits",
                cache: sessionStorageCache,
                cssClasses: {
                    root: 'ais-InfiniteHits center-button',
                    list: 'grid product-grid grid--2-col-tablet-down grid--'+columns_desktop+'-col-desktop',
                    item: 'grid__item',
                },
                templates: {
                    item(data, { html }) {
                        //itemIndex++;
                        const { shortTitle, date } = data;
                        return html`
                            ${renderProductCard(data, data.__hitIndex)}
                        `;
                    },
                    empty: ({ query }, { html }) => {
                        document.body.classList.add('template-search-no-results');
                        const elementsToHide = document.querySelectorAll('.plp-container__left, .collection-load-more');
                        elementsToHide.forEach(element => {
                            element.style.display = 'none';
                        });

                        var breadcrumbTitle = document.querySelector(".JS_breadcrumb_collection_title");
                        var collectionTitleElement  = document.querySelector('.plp-header__text-container h1');
                        var collectionTitle = collectionTitleElement.textContent.trim();
                        
                        if (query) {
                            if (breadcrumbTitle) {
                                breadcrumbTitle.textContent = "Search results for '" + query + "'";
                            }

                            return html`
                                <div class="no-results-heading h4">${no_results_heading} “${query}”</div>
                                <div class="no-results-prompts" innerHTML="${no_results_prompts}"></div>
                            `;
                        } else {
                            if (breadcrumbTitle && collectionTitle) {
                                breadcrumbTitle.textContent = "Search results for '" + collectionTitle + "'";
                            }

                            return html`
                                <div class="no-results-heading h4">${no_results_heading} “${collectionTitle}”</div>
                                <div class="no-results-prompts" innerHTML="${no_results_prompts}"></div>
                            `;
                        }
                    }
                }
            })
        );


        const viewedRenderedHits = {
            render(options) {
              const results = options.results;
              const totalHits = results.nbHits;
              const hitsContainer = document.querySelector('#hits');
              const renderedHits = hitsContainer.querySelectorAll('.ais-InfiniteHits-item').length;
          
              // Update the UI with the total and rendered hits
              stylesLoadMore(renderedHits, totalHits);

            }
        };

        const publisherFilter = instantsearch.widgets.refinementList({
            container: '#publisherFilter',
            attribute: 'publisher',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'                
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    publisherCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                    `;
                }
            }
        });

        const hierarchicalCategoriesFilter = instantsearch.widgets.hierarchicalMenu({
            container: '#hierarchicalCategoriesFilter',
            //sortBy: ['isRefined'],
            //showParentLevel: false,
            //rootPath: 'Root > Book > Non-Fiction',
            cssClasses: {
                root: 'plp-related-collections_categories',
                list: 'plp-related-collections_categories_list',
                link: 'plp-related-collections_categories_item',
                showMore: 'plp-related-collections_showMore'
            },
            attributes: [
                'hierarchicalCategories.lvl0',
                'hierarchicalCategories.lvl1',
                'hierarchicalCategories.lvl2',
            ],
            templates: {
                item(data, { html }) {
                    hierarchicalCategoriesCount++;

                    return html`
                        <a class="${data.cssClasses.link}" href="${data.url}">
                            <span class="${data.cssClasses.label}">${data.label}</span>
                            <span class="${data.cssClasses.count}">${data.count.toLocaleString()}</span>
                        </a>
                    `;
                },
            }
        })

        const authorFilter = instantsearch.widgets.refinementList({
            container: '#authorFilter',
            attribute: 'author',
            searchable: true,
            searchablePlaceholder: translations.products.facets.author,
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'                
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    authorCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                    `;
                }
            }
        });

        const currentFilters = instantsearch.widgets.currentRefinements({
            container: '#currentFilters',
            cssClasses: {
                list: 'plp-related-collections__filters-view-all',
                item: 'plp-related-collections__filters-item',
                label: 'plp-filters__filter-item__label',
                categoryLabel: 'plp-filters__filter-item__label',
                delete: 'plp-related-collections__filters-icon '
            },
            transformItems(items, { results }) {
                const attributeLabelMapping = {
                    'author': translations.products.facets.author,
                    'bindingType': translations.products.facets.binding_type,
                    'priceRanges': translations.products.facets.price,
                    'productType': translations.products.facets.product_type,
                    'publisher': translations.products.facets.publisher,
                    'hierarchicalCategories.lvl0': translations.products.facets.category,
                    'availableConditions': translations.products.product.condition.label
                };
                const clearFiltersButton = document.getElementById('clearFilters');
                if (items.length === 0) {
                    clearFiltersButton.style.display = 'none';
                    return items;
                } else {
                    clearFiltersButton.style.display = 'block';
                    items.forEach((element) => {
                        if (attributeLabelMapping.hasOwnProperty(element.attribute)) {
                            element.label = attributeLabelMapping[element.attribute];
                        }

                        if (element.attribute === 'productType' && Array.isArray(element.refinements)) {
                            element.refinements.forEach(refinement => {
                                refinement.label = refinement.label.replace(/^\d+ - /, '');
                            });
                        }

                        if (element.attribute === 'availableConditions' && Array.isArray(element.refinements)) {
                            element.refinements.forEach(refinement => {
                                refinement.label = translations.products.product.condition[refinement.label.toLowerCase()];
                            });
                        }
                    });
                    return items;
                }
            }
        });

        const bindingTypeFilter = instantsearch.widgets.refinementList({
            container: '#bindingTypeFilter',
            attribute: 'bindingType',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'                
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    bindingTypeCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                    `;
                }
            }
        });

        const priceRangesFilter = instantsearch.widgets.refinementList({
            container: '#priceRangesFilter',
            attribute: 'priceRanges',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    priceRangesCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                    `;
                }
            },
            // Add the transformItems option to sort the price ranges
            transformItems(items) {
                return items.sort((a, b) => {
                    const getStartingPrice = label => parseInt(label.split('-')[0].replace(/^\D+/g, ''), 10);
                    const priceA = getStartingPrice(a.label);
                    const priceB = getStartingPrice(b.label);
        
                    return priceA - priceB;
                }).map(item => {
                    // Prepend the currency symbol to each part of the price range
                    const modifiedLabel = item.label.split('-').map(pricePart => 
                        store_currency_sign + pricePart.trim()).join(' - ');
                    return {...item, label: modifiedLabel};
                });
            }
        });

        const productTypeFilter = instantsearch.widgets.refinementList({
            container: '#productTypeFilter',
            attribute: 'productType',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    productTypeCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                    `;
                }
            }
        });

        const consoleFilter = instantsearch.widgets.refinementList({
            container: '#consoleFilter',
            attribute: 'console',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    consoleCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                      `;
                }
            }
        });

        const platformFilter = instantsearch.widgets.refinementList({
            container: '#platformFilter',
            attribute: 'platform',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    platformCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${label}</label>
                    `;
                }
            }
        });

        const availableConditionsFilter = instantsearch.widgets.refinementList({
            container: '#availableConditionsFilter',
            attribute: 'availableConditions',
            cssClasses: {
                root: 'plp-filters__filter',
                list: 'plp-filters__filter-items',
                item: 'plp-filters__filter-item',
                selectedItem: 'plp-filters__filter-item--selected',
                label: 'plp-filters__filter-item__label'
            },
            templates: {
                item(data, { html }) {
                    const { label, count, url, cssClasses } = data;
                    let labelDisplay = translations.products.product.condition[label.toLowerCase()];
                    availableConditionsCount++;

                    return html`
                        <input type="checkbox" id="${label}" name="${label}" value="0" />
                        <label for="${label}">${labelDisplay}</label>
                    `;
                }
            }
        });


        const hideSkeletonFilters = () => {
            const skeletonFilters = document.querySelectorAll('.skeleton-filter');
            skeletonFilters.forEach(element => {
                element.style.display = 'none';
            });
        };

        setTimeout(hideSkeletonFilters, 100);


        const sortByWidget = instantsearch.widgets.sortBy({
            container: '#plp-sort-by',
            cssClasses: {
              select: 'plp-sorting__sort-by'
            },
            items: [
                {value: globalConfig.algoliaIndexName, label: translations.products.facets.sort_by_items_label.relevance},
                {value: globalConfig.algoliaIndexName + '_salesrank', label: translations.products.facets.sort_by_items_label.sales_rank},
                {value: globalConfig.algoliaIndexName + '_title_asc', label: translations.products.facets.sort_by_items_label.title_asc},
                {value: globalConfig.algoliaIndexName + '_price_asc', label: translations.products.facets.sort_by_items_label.price_asc},
                {value: globalConfig.algoliaIndexName + '_price_desc', label: translations.products.facets.sort_by_items_label.price_desc},
                {value: globalConfig.algoliaIndexName + '_new_arrivals', label: translations.products.facets.sort_by_items_label.new_arrivals}
            ]
        });

        const sortByWidgetMobile = instantsearch.widgets.sortBy({
            container: '#plp-sort-by-mobile',
            cssClasses: {
                select: 'plp-sorting__sort-by plp-sorting__sort-by--mobile'
            },
            items: [
                {value: globalConfig.algoliaIndexName, label: translations.products.facets.sort_by_items_label.relevance},
                {value: globalConfig.algoliaIndexName + '_salesrank', label: translations.products.facets.sort_by_items_label.salesrank},
                {value: globalConfig.algoliaIndexName + '_title_asc', label: translations.products.facets.sort_by_items_label.title_asc},
                {value: globalConfig.algoliaIndexName + '_price_asc', label: translations.products.facets.sort_by_items_label.price_asc},
                {value: globalConfig.algoliaIndexName + '_price_desc', label: translations.products.facets.sort_by_items_label.price_desc},
                {value: globalConfig.algoliaIndexName + '_new_arrivals', label: translations.products.facets.sort_by_items_label.new_arrivals},
            ]
        });
        

        // Order filters: FILTER : DIV ID PARENT
        let filtersData = {
            'hierarchicalCategories': 'hierarchicalCategoriesParent',
            'publisher': 'publisherParent',
            'author': 'authorParent',
            'bindingType': 'bindingTypeParent',
            'productType': 'productTypeParent',
            'priceRanges': 'priceRangesParent',
            'console': 'consoleParent',
            'platform': 'platformParent',
            'availableConditions': 'availableConditionsParent',
        };

        async function getFacetsOrder(apiKey, applicationId, indexName) {
            const url = `https://${applicationId}-dsn.algolia.net/1/indexes/${indexName}/settings`;

            try {
                const response = await fetch(url, {
                    headers: {
                        'X-Algolia-API-Key': apiKey,
                        'X-Algolia-Application-Id': applicationId
                    }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch index settings. HTTP Code: ${response.status}`);
                }

                const settings = await response.json();
                const facetsOrder = settings.renderingContent?.facetOrdering?.facets?.order;

                return facetsOrder || [];
            } catch (error) {
                console.error('Error fetching index settings:', error);
                return [];
            }
        }

        async function sortDivsByFacetsOrder(apiKey, applicationId, indexName) {
            const facetsOrder = await getFacetsOrder(apiKey, applicationId, indexName);
            const parentElement = document.getElementById('filtersParent');
            let orderedDivs = [];
            facetsOrder.forEach(facet => {
                if (filtersData[facet]) {
                    const divId = filtersData[facet];
                    const divElement = document.getElementById(divId);
                    if (divElement) {
                        orderedDivs.push(divElement);
                    }
                }
            });

            Object.keys(filtersData).forEach(facet => {
                if (!facetsOrder.includes(facet)) {
                    const divId = filtersData[facet];
                    const divElement = document.getElementById(divId);
                    if (divElement) {
                        orderedDivs.push(divElement);
                    }
                }
            });

            orderedDivs.forEach(div => {
                parentElement.appendChild(div);
            });
        }


        sortDivsByFacetsOrder(plpApiKey, plpIndexId, globalConfig.algoliaIndexName);



        // Algolia Widgets
        search.addWidget(publisherFilter);
        search.addWidget(hierarchicalCategoriesFilter);
        search.addWidget(authorFilter);
        search.addWidget(priceRangesFilter);
        search.addWidget(bindingTypeFilter);         
        search.addWidget(productTypeFilter);
        search.addWidget(currentFilters);
        search.addWidget(platformFilter);       
        search.addWidget(consoleFilter);
        search.addWidget(availableConditionsFilter);

        search.addWidgets([sortByWidget, sortByWidgetMobile]);
        search.addWidget(viewedRenderedHits);
        search.on('render', debouncedRenderAction);
        search.start();

        // open categories
        function applyAttributesOnWidth() {
            if (window.matchMedia("(min-width: 1024px)").matches) {
                const summaryElement = document.getElementById("Summary-categories-mobile");
                if (summaryElement && summaryElement.getAttribute("aria-expanded") !== "true") {
                    summaryElement.setAttribute("aria-expanded", "true");
                }
                const detailsElement = document.getElementById("Details-categories-mobile");
                if (detailsElement && !detailsElement.hasAttribute("open")) {
                    detailsElement.setAttribute("open", "");
                }
            }
        }

        applyAttributesOnWidth();
        window.addEventListener("resize", applyAttributesOnWidth);


    setTimeout(function () {
        for (const property in filtersData) {
            let propertyCount = eval(property + "Count");
            let propertyDiv = document.getElementById(filtersData[property]);

            if (propertyCount <= 1 && property != 'hierarchicalCategories') {
                propertyDiv.classList.add("hidden");
            }
        }
    }, 500);
});
